/**
 * A module containing polyfills for lodash and the browser.
 * @module abt-utils/polyfill
 */

import _ from 'lodash'
import Promise from 'promise/lib/es6-extensions'

if (!global.Promise) {
  global.Promise = Promise
}

if (!_.fromPairs && _.zipObject) {
  _.fromPairs = _.zipObject
}

if (!_.includes && _.contains) {
  _.includes = _.contains
}

if (!_.mergeWith && _.merge) {
  _.mergeWith = _.merge
}

if (!_.omitBy && _.omit) {
  _.omitBy = _.omit
}



/*****************
 ** WEBPACK FOOTER
 ** ./src/abt-core/polyfill.js
 ** module id = 45
 ** module chunks = 2
 **/